import { render, staticRenderFns } from "./ExamManagementUpload.vue?vue&type=template&id=65260e67&scoped=true"
import script from "./ExamManagementUpload.vue?vue&type=script&lang=js"
export * from "./ExamManagementUpload.vue?vue&type=script&lang=js"
import style0 from "./ExamManagementUpload.vue?vue&type=style&index=0&id=65260e67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65260e67",
  null
  
)

export default component.exports